<template>
    <div class="content">
        <a @click.prevent="redirectToPage"><h2>{{ block.title }}</h2></a>
        <div v-html="block.content"></div>
        <a @click.prevent v-if="hasButton"><button class="button white center-block" @click="redirectToPage">{{ block.button_txt }}</button></a>
    </div>
</template>

<script>
import router from "@/router"

export default {
    props: {
        block: Object,
    },
    computed: {
        hasButton() {

             return (this.block.type != 'Text' ? true : false);
        }
    },
    methods: {
        redirectToPage() {
            if(this.block.type =='Consumer') {
                this.$router.push({ name: 'app-consumer', params: { 'slug': router.currentRoute.params.slug, 'id' : this.block.id }});

                return;
            }
            if(this.block.type =='Complaint') {
                this.$router.push({ name: 'app-complaint', params: { 'slug': router.currentRoute.params.slug, 'id' : this.block.id }});

                return;
            }
            if(this.block.type =='Links') {
                this.$router.push({ name: 'app-links', params: { 'slug': router.currentRoute.params.slug, 'id' : this.block.id }});

                return;
            }
            if(this.block.type =='CustomButton') {
                window.location = this.block.button_url;

                return;
            }

            return;
        },
    }
}
</script>

<style>

</style>